import ApplicationSerializer from 'eflex/serializers/application';

export default class SpindleSerializer extends ApplicationSerializer {
  attrs = {
    task: {
      serialize: false,
      deserialize: false,
    },
    spindleConfigs: {
      serialize: false,
      deserialize: false,
    },
  };
}
